import gql from 'graphql-tag';

export const readAllOwner = gql`
  query readAllOwner($search: String, $page: Int, $take: Int, $sortColumn: String, $sortDirection: String, $filter: String) {
    response: readAllOwner(
      search: $search
      take: $take
      page: $page
      sortColumn: $sortColumn
      sortDirection: $sortDirection,
      filter: $filter
    ) {
    total
      page
      take
      hasMore
      items{
        _id
        name
        integrations{
          socialSites{
            instagram{
              long_lived_token
              short_lived_token
              token_type
              user_id
              expires_in
            }
          }
        }
      }
    }
  }
`;
